"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkPathTarget = checkPathTarget;

function checkPathTarget(target, className) {
  if (!target) return false;
  if (target === document.body) return false;
  if (target.className && target.className.includes && target.className.includes(className)) return true;
  return checkPathTarget(target.parentElement, className);
}